import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';

export const columns: TableColumn[] = [
  { id: 'date', label: 'Date', align: 'left', sortDisabled: true },
  { id: 'name', label: 'Name', align: 'left', sortDisabled: true },
  { id: 'repeat', label: 'Repeat', align: 'left', sortDisabled: true },
  {
    id: 'gate',
    label: 'Gate',
    align: 'left',
    sortDisabled: true,
  },
  {
    id: 'vesselOps',
    label: 'Vessel Ops',
    align: 'left',
    sortDisabled: true,
  },
  { id: 'remarks', label: 'Remarks', align: 'left', sortDisabled: true },
  { id: 'actions', label: 'Actions', align: 'right', sortDisabled: true },
];

const stringMapper = {
  YES: 'Yes',
  NO: 'No',
  SAME_DATE: 'Same day',
  DIFFERENT_DATE: 'Different date',
  NO_REPEAT: 'No repeat',
  PARTIAL: 'Partial',
};

export const mapString = (val: string) => stringMapper[val];
